import { useState } from "react";
import { useLocation } from "react-router-dom";
import { FaRegUser } from "react-icons/fa";
import { IoEyeOffOutline, IoEye } from "react-icons/io5";
import { MdLockOutline } from "react-icons/md";
import api from "../../../lib/axios.js";
import toast, { Toaster } from "react-hot-toast";
import Cookies from "js-cookie";
import "../../css/SelfLogin.css";
import Header from "../../js/Header/Header";
import Footer from "../../js/Footer/footer";
import { Helmet } from "react-helmet-async";
import CryptoJS from "crypto-js";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../services/useAuth.js"; // update path if needed

// ✅ IMPORT IMAGE FROM SRC
import loginImg from "../../../assets/login.webp";

export default function SelfLogin() {

  const SECRET_KEY = process.env.REACT_APP_PASSWORD_ENCRYPTION_KEY;

  const navigate = useNavigate();
const { login } = useAuth();

const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const location = useLocation();
  const title = "Sign In | Test Case Management Tool Portal";
  const description = "Securely sign in to Froth TestOps – your powerful test case management portal. Access real-time insights, streamline QA and boost test execution.";

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!username.trim()) {
    toast.error("Username is required");
    return;
  }

  if (!password) {
    toast.error("Password is required");
    return;
  }

  if (password.length < 6) {
    toast.error("Password must be at least 6 characters");
    return;
  }

  setIsSubmitting(true);

  if (!SECRET_KEY) {
  toast.error("Encryption key missing");
  return;
}

  try {
    const encryptedPassword = CryptoJS.AES.encrypt(
  password,
  SECRET_KEY
).toString();

const response = await login(username, encryptedPassword);
const token = response.data.token;
navigate(
  `/self-servicedashboard?token=${encodeURIComponent(token)}&username=${encodeURIComponent(username)}`
);


    // Store user data (including encrypted password for API calls)
    // localStorage.setItem(
    //   "ssUser",
    //   JSON.stringify({
    //     ...response.data.user,
    //     username,
    //     encryptedPassword, // Store encrypted password for subsequent API calls
    //   })
    // );

    // localStorage.setItem("ssToken", response.data.token);

    // if (typeof window.sessionService !== "undefined") {
    //   window.sessionService.setSessionId(response.data.token);
    // }

    toast.success("Login successful!");

    resetForm();

    setTimeout(() => {
      navigate("/self-servicedashboard");
    }, 1500);
  } catch (error) {
    console.error("Login failed:", error);

    const rawError =
      error?.response?.data?.detail?.message ||
      error?.response?.data?.message ||
      error?.error ||
      error?.message ||
      "Login failed";

    // Ensure errorMessage is always a string, not an Error object
    const errorMessage = rawError instanceof Error
      ? rawError.message
      : String(rawError);

    toast.error(errorMessage);
  } finally {
    setIsSubmitting(false);
  }
};
  const resetForm = () => {
    setUsername("");
    setPassword("");
  };

  return (
    <>
      <Helmet>
        <title>Sign In | Test Case Management Tool Portal</title>

        <meta
          name="description"
          content="Securely sign in to Froth TestOps – your powerful test case management portal. Access real-time insights, streamline QA and boost test execution."
        />

        <meta name="keywords" content="Test Case Management Tool" />

        <link rel="canonical" href="https://frothtestops.com/why-testops" />

        {/* Open Graph Tags */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/images/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://frothtestops.com${location.pathname}`} />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="/images/og-image.jpg" />
      </Helmet>
      <div
        className={`fd-main-wrapper ${location.pathname !== "/" ? "page-padding" : ""}`}
      >
        <Toaster position="top-right" />
        <Header />
        <div className="login-wrapper d-flex align-items-center justify-content-center p-3">
          <div
            className="login-card bg-white shadow-lg row w-100"
            style={{ maxWidth: "900px" }}
          >
            {/* LEFT IMAGE */}
            <div className="col-md-6 d-flex align-items-center justify-content-center p-4">
              <img
                src={loginImg}
                alt="Login"
                className="img-fluid"
                style={{ maxWidth: "300px" }}
              />
            </div>

            {/* RIGHT FORM */}
            <div className="col-md-6 login-right p-4 d-flex flex-column justify-content-center">
              <h3 className="text-center login-title mb-2">Welcome Back</h3>
              <p className="text-center login-subtitle mb-4">
                Sign in your account
              </p>

              <form onSubmit={handleSubmit}>
                <div className="position-relative mb-3">
                  <FaRegUser className="input-icon" />
                  <input
                    type="text"
                    placeholder="Username"
                    className="form-control input-field"
                    required
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>

                <div className="position-relative mb-3">
                  <MdLockOutline className="input-icon" />
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    className="form-control input-field"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />

                  <div
                    className="eye-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <IoEyeOffOutline /> : <IoEye />}
                  </div>
                </div>

                <button
  type="submit"
  className="login-btn w-100 text-white"
  disabled={isSubmitting}
>
  {isSubmitting ? "Logging in..." : "Login"}
</button>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
